import { styled } from 'baseui'
import { FlexBetween, FlexColumn } from '@/shared/theme/styled-components'

export const StyledFormServicesPanel = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',

  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
}))

export const StyledServiceCard = styled(FlexColumn, ({ $theme }) => ({
  padding: '1rem',
  backgroundColor: $theme.colors.white,
  borderRadius: $theme.borders.radius400,
  boxShadow: $theme.lighting.shadow400,

  '@media screen and (min-width: 768px)': {
    flex: '0 1 calc((100% - 1rem) / 2)',
  },

  '@media screen and (min-width: 1100px)': {
    flex: '0 1 calc((100% - 2rem) / 3)',
  },
}))

export const StyledHeader = styled(FlexBetween, () => ({
  marginBottom: '.5rem',
}))

export const StyledTitle = styled('h2', ({ $theme }) => ({
  margin: '0',
  color: $theme.colors.primary,
  ...$theme.typography.HeadingSmall,
}))

export const titleIconOverrides = {
  Svg: {
    style: () => ({
      marginRight: '.5rem',
    }),
  },
}

export const checkboxOverrides = {
  Label: {
    style: () => ({
      marginRight: 'auto',
    }),
  },
}

export const buttonOverrides = {
  ControlContainer: {
    style: () => ({
      marginTop: '2rem',
    }),
  },
}

export const checkboxFCOverrides = {
  ControlContainer: {
    style: () => ({
      marginTop: 'auto',
      marginBottom: '0',
      width: 'auto',
    }),
  },
}
